import { render } from "./UploadTest.vue?vue&type=template&id=185a3b2c&scoped=true"
import script from "./UploadTest.vue?vue&type=script&lang=js"
export * from "./UploadTest.vue?vue&type=script&lang=js"

import "./UploadTest.vue?vue&type=style&index=0&id=185a3b2c&scoped=true&lang=scss"

import exportComponent from "D:\\CTS_SURAJ\\Edu Katta\\Private\\Edukatta_Private_Managment_UI\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-185a3b2c"]])

export default __exports__